module.exports = __webpack_public_path__ + "static/mcreilly-logo-7e8682d9e44d1b4cfef65d1d3cf5288b.svg";